export enum CrispSegmentsEnum {
  chat = 'chat',
  support = 'support',
  dashboard = 'dashboard',
  onSignupPage = 'on-signup-page',
  onLoginPage = 'on-login-page',
}